import { VERTICAL_KEYS } from '../vertical.js';
import type { VerticalLandingContent } from './types.js';

// =============================================================================
// MCMV-imobiliário landing content. Mirrors the strings that used to live
// hard-coded in apps/web/src/messages.ts and apps/web/src/pages/public/*.
// Migrating to this structure is *visually identical* · Angel's and Wesley's
// landings render exactly the same copy.
// =============================================================================

export const mcmvLandingContent: VerticalLandingContent = {
  verticalKey: VERTICAL_KEYS.MCMV_IMOBILIARIO,

  brokerSubtitle: 'Especialista MCMV',
  brokerHeaderCta: 'Quero simular',
  brokerCardLabel: 'Seu corretor',
  brokerCardCta: 'Começar simulação',

  heroBadge: 'Minha Casa Minha Vida · análise gratuita',
  heroHeadlineDefault:
    'Descubra em 2 minutos se você pode comprar seu primeiro imóvel',
  heroSubheadlineDefault:
    'Faço uma análise gratuita do seu perfil pelas regras do MCMV e te mostro o próximo passo.',
  heroPrimaryCta: 'Quero saber agora',
  heroSecondaryCta: 'Ver empreendimentos',
  trustBadges: ['Grátis', '2 minutos', 'Sem compromisso'],

  howItWorksTitle: 'Como funciona',
  howItWorksSubtitle: 'Três passos pra entender se você se qualifica.',
  howItWorksSteps: [
    {
      title: 'Preencha o formulário',
      body: 'São 4 etapas rápidas com perguntas sobre renda, FGTS e perfil de crédito.',
    },
    {
      title: 'Suas respostas vão prontas',
      body: 'Tudo o que importa pro MCMV (renda, FGTS e crédito) chega organizado no WhatsApp.',
    },
    {
      title: 'Fale comigo no WhatsApp',
      body: 'Se você se qualifica, te ajudo com o próximo passo do financiamento.',
    },
  ],

  aboutTitle: 'Quem vai te atender',

  listingsTitle: 'Empreendimentos disponíveis',
  listingsSubtitle: 'Imóveis cuidadosamente selecionados pra famílias que usam MCMV.',

  faqTitle: 'Perguntas frequentes',
  faqSubtitle: 'O básico do MCMV que vale a pena saber antes de simular.',
  faqItems: [
    {
      q: 'Qual é o limite de renda pra usar o MCMV?',
      a: 'O MCMV atende famílias com renda mensal de até R$ 13.000,00 (Faixa 4). Quanto menor a renda, melhores as condições · Faixa 1 (até R$ 3.200), Faixa 2 (até R$ 5.000) e Faixa 3 (até R$ 9.600) têm subsídios e juros mais baixos. A simulação aqui considera o teto geral do programa.',
    },
    {
      q: 'Preciso ter saldo de FGTS pra comprar?',
      a: 'Não é obrigatório, mas tendo FGTS você consegue usar como entrada ou amortizar o financiamento. Isso pode aumentar significativamente o valor do imóvel que cabe no seu bolso.',
    },
    {
      q: 'Quanto preciso ter de entrada?',
      a: 'O MCMV permite financiamentos com pouca entrada · em alguns casos quase tudo financiado, dependendo do enquadramento. Mesmo assim, ter alguma reserva pra cartório e ITBI ajuda.',
    },
    {
      q: 'E se meu nome está no SPC/Serasa, ainda posso?',
      a: 'A análise final de crédito é do banco, mas restrições ativas em geral inviabilizam a contratação. Vale a pena conversar pra entender o tipo de pendência e o melhor caminho.',
    },
    {
      q: 'Posso usar o MCMV se já tenho um imóvel?',
      a: 'A regra é não ter imóvel residencial onde você mora ou trabalha. Quem tem imóvel quitado em outra cidade, por exemplo, pode se enquadrar · vale conversar pra confirmar a sua situação.',
    },
    {
      q: 'Já comprei pelo MCMV antes. Posso usar de novo?',
      a: 'A regra geral é que quem já se beneficiou do programa não pode usar novamente. Existem exceções em casos específicos · vale conversar pra ver a sua situação.',
    },
  ],

  finalCtaTitle: 'Vamos descobrir se você já pode comprar?',
  finalCtaSubtitle: 'Leva 2 minutos e a conversa no WhatsApp já começa com tudo pronto.',
  finalCtaButton: 'Fazer minha simulação',

  footerLabel: 'Sistema de qualificação MCMV por NexoFácil',

  listingBadge: 'Disponível pelo MCMV',
  listingCta: 'Quero saber se posso comprar',
  listingCtaHint: 'Análise gratuita em 2 minutos',
  listingNoPriceHint: 'Faça a simulação pra receber a tabela atualizada.',
  backToListings: 'Voltar aos empreendimentos',
};
